<h2>Hilfethemen für die aktuelle Seite</h2>
<div class="bigDialog">
	<div class="leftPane">
		<ul>
			@for (anchor of helpAnchorsForVisibleElements; track anchor) {
				<li [style.margin-left.em]="getIndentEm(anchor)">
					<a href="#" (click)="selectAnchor(anchor); $event.preventDefault()">{{ getTitle(anchor) }}</a>
				</li>
			}
		</ul>
		@if (browserHelpLink) {
			<a class="browser-help-link" [href]="browserHelpLink" (click)="openBrowserHelp($event)">{{ browserHelpLabel }}</a>
		}
	</div>
	<iframe [src]="helpFileUrl"></iframe>
</div>
<div>
	<button mat-flat-button color="primary" (click)="closeDialog()" (keydown.enter)="closeDialog()">Schliessen</button>
	<button mat-flat-button color="primary" (click)="newTab()" (keydown.enter)="newTab()">neuer Tab</button>
</div>
